import { LayoutDashboard, LogIn } from 'lucide-react';
import { useAuth } from '../hooks/useAuth';
import { BRAND_NAME } from '../config/brand';

export default function LoginPage() {
  const { login } = useAuth();

  return (
    <div className="min-h-screen bg-bg flex items-center justify-center">
      <div className="bg-surface border border-border rounded-xl p-8 w-full max-w-md text-center">
        <div className="flex justify-center mb-6">
          <LayoutDashboard className="w-16 h-16 text-primary" />
        </div>
        <h1 className="text-2xl font-bold text-textPrimary mb-2">{BRAND_NAME}</h1>
        <p className="text-textSecondary mb-8">
          Sign in with your Cargill account to access the multi-agent orchestration platform.
        </p>
        <button
          onClick={() => login()}
          className="w-full flex items-center justify-center gap-3 px-6 py-3 bg-primary text-textOnPrimary rounded-lg hover:bg-primary-hover transition-colors font-medium"
        >
          <LogIn className="w-5 h-5" />
          Sign in with Cargill
        </button>
        <p className="text-xs text-textTertiary mt-6">
          Powered by Azure Entra ID (Microsoft SSO)
        </p>
      </div>
    </div>
  );
}
